<template>
  <div>
    <CContainer>
      <CRow class="justify-content-center mt-4">
        <CCol md="12 text-center">
          <h1 class="mb-4">New Releases &nbsp;&nbsp;</h1>
          <div v-if="releasesDoc && releasesDoc.release_doc_url">
            <iframe
              :src="releasesDoc.release_doc_url"
              class="releases-iframe"
            />
          </div>
          <div v-if="!releases">No releases</div>
          <div v-else>
            <div
              v-for="(release, index) in releases"
              :key="index"
              class="mb-5 modal-height"
            >
              <h3 class="text-info">
                Pass Updates {{ release.version }}
                {{ $helpers.transformDate(release.created_at, "MMMM,DD") }}
              </h3>
              <div v-html="release.content" />
            </div>
          </div>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>
<script>
import { mapGetters } from "vuex"
export default {
  name: "NewReleases",
  components: {},
  computed: {
    ...mapGetters({
      releases: "releases/releases",
      releasesDoc: "releases/releasesDoc"
    })
  },
  created() {
    this.$store.dispatch("releases/getAllReleases")
    this.$store.dispatch("releases/getNewReleases")
  }
}
</script>
